import { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CAROUSEL } from "@/lib/data";

export const BWCarousel = () => {
  const [index, setIndex] = useState(0);
  const count = CAROUSEL.length;

  const go = useCallback((dir) => {
    setIndex((i) => (i + dir + count) % count);
  }, [count]);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % count), 4500);
    return () => clearInterval(id);
  }, [count]);

  return (
    <div
      className="relative w-full h-[420px] md:h-[560px] rounded-[2rem] overflow-hidden shadow-xl bg-charcoal"
      data-testid="hero-carousel"
    >
      <AnimatePresence mode="popLayout">
        <motion.img
          key={index}
          src={CAROUSEL[index]}
          alt={`Chief Apostle Leonard Lucas Jr. ${index + 1}`}
          initial={{ opacity: 0, scale: 1.06 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="absolute inset-0 w-full h-full object-cover grayscale contrast-[1.08]"
        />
      </AnimatePresence>

      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/10 pointer-events-none" />

      <button
        onClick={() => go(-1)}
        data-testid="carousel-prev"
        aria-label="Previous image"
        className="absolute left-4 top-1/2 -translate-y-1/2 grid place-items-center w-11 h-11 rounded-full bg-white/15 backdrop-blur-md text-white transition-all hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white"
      >
        <ChevronLeft size={22} />
      </button>
      <button
        onClick={() => go(1)}
        data-testid="carousel-next"
        aria-label="Next image"
        className="absolute right-4 top-1/2 -translate-y-1/2 grid place-items-center w-11 h-11 rounded-full bg-white/15 backdrop-blur-md text-white transition-all hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white"
      >
        <ChevronRight size={22} />
      </button>

      <div className="absolute bottom-5 left-0 right-0 flex justify-center gap-2.5">
        {CAROUSEL.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            data-testid={`carousel-dot-${i}`}
            aria-label={`Go to image ${i + 1}`}
            className={`h-1.5 rounded-full transition-all ${
              i === index ? "w-8 bg-white" : "w-2.5 bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  );
};
